import { NgModule } from '@angular/core';
import { ImpersonatorComponent } from './impersonator.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [ImpersonatorComponent],
  imports: [SharedModule],
  exports: [ImpersonatorComponent]
})
export class ImpersonatorModule { }
